import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.search";
import "core-js/modules/web.timers";
import url from 'url';
import { isUndef } from '@/lib/utils'; // todo: 当发生update时，需要将已有的setTimeout关闭

function tryLoad(el, binding) {
  if (el.tagName.toLowerCase() !== 'img') {
    return;
  }

  var src = el.getAttribute('src');

  if (!src) {
    return;
  }

  var result = url.parse(src, true); // @ts-ignore

  if (isUndef(el.__try_count)) {
    // @ts-ignore
    el.__try_count = 3;
  } // 加载失败


  el.onerror = function (e) {
    // @ts-ignore
    // @ts-ignore
    if (el.__try_count <= 0) {
      return;
    } // @ts-ignore


    el.__try_count--;
    setTimeout(function () {
      result.search = null;
      result.query.t = Math.random().toFixed(3);
      el.setAttribute('src', url.format(result));
    }, 1000);
  };
}

var tryImage = {
  bind: tryLoad,
  update: tryLoad
};
export default tryImage;